import { createSelector } from "@reduxjs/toolkit";

export const getStorageSearchParams = (state) => state.priceOffer.storageSearchParams;
export const getPriceOfferColumns = (state) => state.priceOffer.priceOfferColumns;
export const getPriceOfferSelectedColumns = (state) => state.priceOffer.selectedColumns;

export const getPriceOfferSelectedColumnById = createSelector([getPriceOfferSelectedColumns], (columns) => {
	return columns.reduce((acc, column) => {
		return {
			...acc,
			[column.id]: column,
		};
	}, {});
});
